import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import {
  getBannerContainerList,
  getBannerContainerThreeFoursEnabled,
} from 'store/SharedZone/selectors';
import { BannerContainer } from 'bricks/_landings';
import { onClickBanner, onSwitchBanners, onMountBanners } from 'store/SharedZone/actions';
import {
  getThreeFoursAvailability,
  getFrameBannerPosition,
} from 'store/widgets/ThreeFours/selectors';
import FrameBanner from 'widgets/ThreeFours/components/FrameBanner';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function BannerContainerWithOutFrame(props) {
  const threeFoursProps = {};
  if (props.threeFoursAvailability && props.threeFoursEnabled) {
    threeFoursProps.outFrame = <FrameBanner />;
    threeFoursProps.outFramePosition = props.threeFoursPosition;
  }
  return (
    <div className={cx('wrapper')}>
      <BannerContainer {...threeFoursProps} {...props} />
    </div>
  );
}

BannerContainerWithOutFrame.propTypes = {
  threeFoursAvailability: PropTypes.bool,
  threeFoursPosition: PropTypes.number,
  threeFoursEnabled: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  list: getBannerContainerList(state),
  isMobile: isScreenBelow800(state),
  threeFoursAvailability: getThreeFoursAvailability(state),
  threeFoursPosition: getFrameBannerPosition(state),
  threeFoursEnabled: getBannerContainerThreeFoursEnabled(state),
});

const mapDispatchToProps = {
  onBannerClick: onClickBanner,
  onSwitch: onSwitchBanners,
  onMount: onMountBanners,
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerContainerWithOutFrame);
